module.exports = " <div class=\"boot-screen stretchy\" v-on:click=goNext> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BootScreen.vue
// module id = 172
// module chunks = 2